import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import i18n from '../i18n';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: () => import('@/pages/dashboard'),
      meta: {
        auth: true,
        breadcrumbs: [
          { name: i18n.t('navigation.home'), link: 'dashboard', icon: 'home' },
        ],
      },
    },
    {
      path: '/signworkflows/create',
      name: 'createSignworkflow',
      component: () => import('@/pages/signworkflows/createPage'),
      props: true,
      meta: {
        auth: true,
        breadcrumbs: [
          { name: i18n.t('navigation.home'), link: 'dashboard', icon: 'home' },
          { name: i18n.t('navigation.createSignbook') },
        ],
      },
    },
    {
      path: '/signworkflows/:tab',
      name: 'signworkflows',
      component: () => import('@/pages/signworkflows/signworkflows'),
      props: true,
      meta: {
        auth: true,
        breadcrumbs: [
          { name: i18n.t('navigation.home'), link: 'dashboard', icon: 'home' },
          { name: '' },
        ],
      },
    },
    {
      path: '/signworkflows/:signBookId/edit',
      name: 'signworkflow.edit',
      component: () => import('@/pages/signworkflows/edit'),
      props: true,
      meta: {
        auth: true,
        breadcrumbs: [
          { name: i18n.t('navigation.home'), link: 'dashboard', icon: 'home' },
          { name: i18n.t('navigation.signbookDetail') },
        ],
      },
    },
    {
      path: '/guestSignworkflows/details',
      name: 'detailsGuestSignworkflow',
      component: () => import('@/pages/signworkflows/guestDetails'),
      props: true,
      meta: {
        auth: true,
        guest: true,
      },
    },
    {
      path: '/thirdPartySignworkflow',
      name: 'thirdPartySignworkflow',
      component: () => import('@/pages/signworkflows/thirdPartySignworkflow'),
      props: true,
      meta: {
        auth: true,
        guest: true,
      },
    },
    {
      path: '/guestSignworkflows/:signBookId/sign',
      name: 'guestSignworkflows.sign',
      component: () => import('@/pages/signworkflows/sign'),
      props: true,
      meta: {
        auth: true,
        guest: true,
        breadcrumbs: [
          { name: i18n.t('navigation.home'), link: 'dashboard', icon: 'home' },
          { name: i18n.t('navigation.signSignbook') },
        ],
      },
    },
    {
      path: '/guestSignworkflows',
      name: 'guestSignworkflows',
      component: () => import('@/pages/signworkflows/guestSignworkflows'),
      props: true,
      meta: {
        auth: true,
        guest: true,
      },
    },
    {
      path: '/guestSignworkflows/access',
      name: 'guestSignworkflows.access',
      component: () => import('@/pages/signworkflows/guestSignworkflows'),
      props: true,
      meta: {
        auth: true,
        guest: true,
      },
    },
    {
      path: '/templates/:templateId/use',
      name: 'templates.use',
      props: true,
      component: () => import('@/pages/signworkflows/createPage.vue'),
      meta: {
        auth: true,
        breadcrumbs: [
          { name: i18n.t('navigation.home'), link: 'dashboard', icon: 'home' },
          { name: i18n.t('navigation.allTemplates'), link: 'templates.all' },
          { name: i18n.t('navigation.useTemplate') },
        ],
      },
    },
    {
      path: '/templates',
      component: () => import('@/pages/templates/index.vue'),
      children: [
        {
          path: '',
          name: 'templates.all',
          component: () => import('@/pages/templates/all.vue'),
          meta: {
            auth: true,
            breadcrumbs: [
              { name: i18n.t('navigation.home'), link: 'dashboard', icon: 'home' },
              { name: i18n.t('navigation.allTemplates') },
            ],
          },
        },
        /* {
          path: 'mine',
          name: 'templates.index.mine',
        }, */
      ],
      meta: {
        auth: true,
      },
    },

    {
      path: '/settings',
      redirect: '/settings/users',
    },
    {
      path: '/settings/users',
      name: 'settings.users.index',
      component: () => import('@/pages/settings/users/index.vue'),
      meta: {
        auth: true,
        breadcrumbs: [
          { name: i18n.t('navigation.home'), link: 'dashboard', icon: 'home' },
          { name: i18n.t('navigation.users') },
        ],
      },
    },
    {
      path: '/settings/users/create',
      name: 'settings.users.create',
      component: () => import('@/pages/settings/users/create.vue'),
      meta: {
        auth: true,
        breadcrumbs: [
          { name: i18n.t('navigation.home'), link: 'dashboard', icon: 'home' },
          { name: i18n.t('navigation.users'), link: 'settings.users.index' },
          { name: i18n.t('navigation.createUser') },
        ],
      },
    },
    {
      path: '/settings/users/:userId',
      name: 'settings.users.edit',
      props: true,
      component: () => import('@/pages/settings/users/edit.vue'),
      meta: {
        auth: true,
        breadcrumbs: [
          { name: i18n.t('navigation.home'), link: 'dashboard', icon: 'home' },
          { name: i18n.t('navigation.users'), link: 'settings.users.index' },
          { name: '' },
        ],
      },
    },
    {
      path: '/settings/groups/:groupId',
      name: 'settings.groups.edit',
      component: () => import('@/pages/settings/groups/edit.vue'),
      props: true,
      meta: {
        auth: true,
        breadcrumbs: [
          { name: i18n.t('navigation.home'), link: 'dashboard', icon: 'home' },
          { name: i18n.t('navigation.userGroups'), link: 'settings.groups.index' },
          { name: '' },
        ],
      },
    },
    {
      path: '/settings/groups',
      name: 'settings.groups.index',
      component: () => import('@/pages/settings/groups/index.vue'),
      meta: {
        auth: true,
        breadcrumbs: [
          { name: i18n.t('navigation.home'), link: 'dashboard', icon: 'home' },
          { name: i18n.t('navigation.userGroups') },
        ],
      },
    },
    {
      path: '/settings/groups/create',
      name: 'settings.groups.create',
      component: () => import('@/pages/settings/groups/create.vue'),
      meta: {
        auth: true,
        breadcrumbs: [
          { name: i18n.t('navigation.home'), link: 'dashboard', icon: 'home' },
          { name: i18n.t('navigation.userGroups'), link: 'settings.groups.index' },
          { name: i18n.t('navigation.createGroup') },
        ],
      },
    },
    {
      path: '/signatories',
      redirect: '/signatories/internal',
    },
    {
      path: '/signatories/external',
      name: 'signatories.external.index',
      component: () => import('@/pages/signatories/external/index.vue'),
      meta: {
        auth: true,
        breadcrumbs: [
          { name: i18n.t('navigation.home'), link: 'dashboard', icon: 'home' },
          { name: i18n.t('navigation.externalSignatories') },
        ],
      },
    },
    {
      path: '/signatories/social',
      name: 'signatories.social.index',
      component: () => import('@/pages/signatories/social/index.vue'),
      meta: {
        auth: true,
        breadcrumbs: [
          { name: i18n.t('navigation.home'), link: 'dashboard', icon: 'home' },
          { name: i18n.t('navigation.socialSignatories') },
        ],
      },
    },
    {
      path: '/signatories/internal',
      name: 'signatories.internal.index',
      component: () => import('@/pages/signatories/internal/index.vue'),
      meta: {
        auth: true,
        breadcrumbs: [
          { name: i18n.t('navigation.home'), link: 'dashboard', icon: 'home' },
          { name: i18n.t('navigation.internalSignatories') },
        ],
      },
    },
    {
      path: '/signatories/social/create',
      name: 'signatories.social.create',
      component: () => import('@/pages/signatories/social/create'),
      meta: {
        auth: true,
        breadcrumbs: [
          { name: i18n.t('navigation.home'), link: 'dashboard', icon: 'home' },
          { name: i18n.t('navigation.socialSignatories'), link: 'signatories.social.index' },
          { name: i18n.t('navigation.createSocialSignatory') },
        ],
      },
    },
    {
      path: '/signatories/social/:userId',
      name: 'signatories.social.edit',
      props: true,
      component: () => import('@/pages/signatories/social/edit.vue'),
      meta: {
        auth: true,
        breadcrumbs: [
          { name: i18n.t('navigation.home'), link: 'dashboard', icon: 'home' },
          { name: i18n.t('navigation.socialSignatories'), link: 'signatories.social.index' },
          { name: '' },
        ],
      },
    },
    {
      path: '/signatories/external/create',
      name: 'signatories.external.create',
      component: () => import('@/pages/signatories/external/create'),
      meta: {
        auth: true,
        breadcrumbs: [
          { name: i18n.t('navigation.home'), link: 'dashboard', icon: 'home' },
          { name: i18n.t('navigation.externalSignatories'), link: 'signatories.external.index' },
          { name: i18n.t('navigation.createExternalSignatory') },
        ],
      },
    },
    {
      path: '/signatories/external/:signId',
      name: 'signatories.external.edit',
      props: true,
      component: () => import('@/pages/signatories/external/edit'),
      meta: {
        auth: true,
        breadcrumbs: [
          { name: i18n.t('navigation.home'), link: 'dashboard', icon: 'home' },
          { name: i18n.t('navigation.externalSignatories'), link: 'signatories.external.index' },
          { name: '' },
        ],
      },
    },
    {
      path: '/accessToken/:stepUuid/renew',
      name: 'accessToken.renew',
      component: () => import('@/pages/accessTokenRenewal'),
      props: true,
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/login'),
    },
    {
      path: '/login/:sessionId',
      name: 'login.sessionId',
      props: true,
      async beforeEnter(to, from, next) {
        try {
          const session = {
            token: to.params.sessionId,
            guest: false,
            auth: true,
          };
          const response = await store.dispatch('auth/loginWithSession', session);
          if (response && store.state.auth.session.auth) {
            next({ name: 'dashboard' });
          }
        } catch (e) {
          next({ path: 'login' });
        }
      },
    },
    {
      path: '/gsign/:id/:login/:password',
      name: 'gSignLogin-withpassword',
      component: () => import('@/pages/login'),
      props: true,
    },
    {
      path: '/gsign/:id',
      name: 'gSignLogin',
      component: () => import('@/pages/login'),
      props: true,
    },
    {
      path: '/gaccess/:id/:login/:password',
      name: 'gAccessLogin',
      component: () => import('@/pages/login'),
      props: true,
    },
    {
      path: '/sign/:stepUuid',
      name: 'stepSignLogin',
      props: true,
      async beforeEnter(to, from, next) {
        try {
          const response = await store.dispatch('auth/stepLogin', { uuid: to.params.stepUuid });
          if (response) {
            if (store.state.auth.session.auth) {
              next({ name: 'guestSignworkflows.sign', params: { signBookId: response.data.relatedSignbookId } });
            }
          }
        } catch (e) {
          if (e.data.message === 'access token not valid anymore') {
            next({ name: 'accessToken.renew', params: { stepUuid: to.params.stepUuid } });
          } else {
            next({ path: 'login' });
          }
        }
      },
    },
    {
      path: '/access/:stepUuid',
      name: 'stepAccessLogin',
      props: true,
      async beforeEnter(to, from, next) {
        try {
          const response = await store.dispatch('auth/stepLogin', { uuid: to.params.stepUuid });
          if (response) {
            if (!store.state.auth.session.guest && store.state.auth.session.auth) {
              next({ name: 'signworkflow.edit', params: { signBookId: response.data.relatedSignbookId, fromTab: 'sent' } });
            } else {
              next({ name: 'guestSignworkflows.access', params: { signBookId: response.data.relatedSignbookId } });
            }
          }
        } catch (e) {
          if (e.data.message === 'access token not valid anymore') {
            next({ name: 'accessToken.renew', params: { stepUuid: to.params.stepUuid } });
          } else {
            next({ path: 'login' });
          }
        }
      },
    },
    {
      path: '/tp-access/:thirdPartyAccessId',
      name: 'thirdParty-login',
      props: true,
      async beforeEnter(to, from, next) {
        try {
          const response = await store.dispatch('auth/thirdPartyLogin', { uuid: to.params.thirdPartyAccessId });
          if (response.token) {
            next({ path: '/thirdPartySignworkflow' });
          }
        } catch (e) {
          next({ path: 'login' });
        }
      },
    },
    {
      path: '/profile',
      name: 'profile.index',
      component: () => import('@/pages/profile'),
      props: true,
      meta: {
        auth: true,
        breadcrumbs: [
          { name: i18n.t('navigation.home'), link: 'dashboard', icon: 'home' },
          { name: i18n.t('navigation.profile') },
        ],
      },
    },
    /* {
      path: '/templates/create',
      component: () => import('@/pages/templates/create.vue'),
      children: [
        {
          path: 'add-documents-and-recipients',
          name: 'templates.create.addDocumentsAndRecipients',
          meta: {
            auth: true,
          },
        },
        {
          path: 'add-fields',
          name: 'templates.create.addFields',
          meta: {
            auth: true,
          },
        },
        {
          path: 'finish-and-save',
          name: 'templates.create.finishAndSave',
          meta: {
            auth: true,
          },
        },
      ],
      meta: {
        auth: true,
      },
    }, */
    {
      path: '*',
      redirect: '/dashboard',
    },
  ],
});

router.afterEach((to, from) => {
  const mainLayout = document.getElementsByClassName('eui-o-layout__main')[0];
  if (mainLayout) {
    mainLayout.scrollTop = 0;
  }
  if (to.matched.some(m => m.meta.auth) && store.state.auth.session.auth && !store.state.auth.session.guest) {
    if (store.state.auth.user === undefined) {
      store.dispatch('auth/getUserInfos');
    }
    if (store.state.auth.usageDatas === undefined) {
      store.dispatch('auth/getUsageDatas');
    }
  }
});

router.beforeEach((to, from, next) => {
  if (to.name === 'login' && store.state.auth.session.auth && to.params.sessionId !== undefined) {
    store.dispatch('auth/clearAll');
    store.dispatch('auth/callApiLogout').then(() => {
      next();
    });
  } else if (to.name === 'login' && store.state.auth.session.auth) {
    if (store.state.auth.session.guest) {
      next({
        name: 'guestSignworkflows',
      });
    } else {
      next({
        name: 'dashboard',
      });
    }
  } else if (to.name === 'gSignLogin' || to.name === 'gAccessLogin' || to.name === 'stepSignLogin' || to.name === 'stepAccessLogin' || to.name === 'thirdParty-login') {
    store.dispatch('auth/clearAll');
    store.dispatch('auth/callApiLogout').then(() => {
      next();
    });
  } else if (to.matched.some(m => m.meta.auth) && !store.state.auth.session.auth) {
    next({
      name: 'login',
    });
  } else if (to.matched.some(m => m.meta.guest) && !store.state.auth.session.guest && store.state.auth.session.auth) {
    if (to.name === 'guestSignworkflows.sign' || to.name === 'guestSignworkflows.access') {
      next();
    } else {
      next({
        name: 'dashboard',
      });
    }
  } else if (!(to.matched.some(m => m.meta.guest)) && store.state.auth.session.guest) {
    next({
      name: 'guestSignworkflows',
    });
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js